import { INodeBasePanelElementConfig } from 'components/basic/NodeBase/NodeBase';
import { IWorkflowSchemaTrigger } from 'types/rofl';
import { RWListRules } from '@nextroll/ar-rollworks-list-builder';

export const TRIGGER_RULE_TYPES = {
    LIST_MEMBERSHIP: 'list_membership',
    CUSTOM: 'custom',
} as const;

export type TriggerRuleType = typeof TRIGGER_RULE_TYPES[keyof typeof TRIGGER_RULE_TYPES];
export type TriggerRuleTypeListMembership = typeof TRIGGER_RULE_TYPES.LIST_MEMBERSHIP;
export type TriggerRuleTypeCustom = typeof TRIGGER_RULE_TYPES.CUSTOM;

/**
 * TriggerNodeTypeOption contains the attributes needed to render an option for the trigger type.
 */
export type TriggerRuleTypeOption = {
    type: TriggerRuleType;
    label: string;
    tooltip: string;
};

export interface ITriggerElementConfig {
    elementConfig: INodeBasePanelElementConfig;
    show: boolean;
}

/**
 * IContactListOptionRaw represents a raw contact list.
 */
export interface IContactListOption {
    eid?: string;
    name: string;
    size?: number;
    status?: string;
    rules?: RWListRules;
}

/**
 * ITriggerConfigListMembership represents the configuration of a trigger node when the selected type is
 * contact list membership.
 * This extends IWorkflowSchemaTrigger because it needs to be compatible with it. It's a super set of the trigger
 * schema that includes selected values that are not reflected in the schema.
 */
export interface ITriggerNodeConfigListMembership extends IWorkflowSchemaTrigger {
    ruleType: TriggerRuleTypeListMembership;
    selectedContactList?: IContactListOption;
}

/**
 * ITriggerConfigCustom represents the configuration of a trigger node when the selected type is
 * custom criteria.
 * This extends IWorkflowSchemaTrigger because it needs to be compatible with it. It's a super set of the trigger
 * schema that includes selected values that are not reflected in the schema.
 */
export interface ITriggerNodeConfigCustom extends IWorkflowSchemaTrigger {
    ruleType: TriggerRuleTypeCustom;
    rulesHaveErrors?: boolean;
}

/**
 * ITriggerNodeConfig represents the configuration of a trigger node. The interfaces here are a superset
 * of IWorkflowSchemaTrigger, which is the expected content of the node's data.
 */
export type ITriggerNodeConfig = ITriggerNodeConfigListMembership | ITriggerNodeConfigCustom;
